import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockDef } from '../../defs/map';
import {
  _spawnBaseBlockEntity,
  setBlockEntityViewLayer,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { GrassBlockProps } from './GrassBlock';
import { GrassBlockComponent } from './GrassBlockComponent';

const GrassBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  GrassBlockComponent,
);

export type GrassBlockEntity = EntityType<typeof GrassBlockEntityDef>;

export function _spawnGrassBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: GrassBlockProps,
  position: Vector2,
): GrassBlockEntity {
  const entity = _spawnBaseBlockEntity(
    GrassBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockGrass: {
        props,
        option: def.option,
      },
    },
  );

  entity.c.view2d.view.addChild(entity.c.blockGrass.view);
  setBlockEntityViewLayer(scene, entity, 'front');

  return entity;
}
